<template>
  <div class="content-wrapper">
    <section class="group-form">
      <GroupEditForm/>
    </section>
  </div>
</template>

<script>
import GroupEditForm from '@/components/group/GroupEditForm.vue'

export default {
  name: 'GroupEdit',
  components: {
    GroupEditForm
  }
}
</script>
